import type { AuthApi } from "./AuthContext";

/**
 * Dynamically loads the appropriate AuthApi implementation based on environment config.
 *
 * - If `REACT_APP_AUTH_MODE` is set to `"mock"`, loads the local mockAuth implementation.
 * - Otherwise, defaults to the MSAL/Azure AD B2C implementation.
 * - Uses dynamic `import()` so unused auth code is not bundled unless needed.
 */

export async function loadAuthImpl(): Promise<AuthApi> {
    if (process.env.REACT_APP_AUTH_MODE === "ms_entra_id") {
        const { makeAuth } = await import("./impls/msalAuth");
        return makeAuth();
    } else {
        const { makeAuth } = await import("./impls/mockAuth");
        return makeAuth();
    }
}
